import React, { useState, useEffect } from "react";
import * as S from "./styled";
import { useInView } from "react-intersection-observer";
import { useMediaQuery } from "@/hooks/useMediaQuery";

const sliderConfig = {
  pageDots: false,
  wrapAround: true,
  contain: true,
  cellAlign: "left",
  prevNextButtons: false,
  adaptiveHeight: false,
  autoPlay: true,
};
const desktopSlides = [
  "/screens/desktop/1.png",
  "/screens/desktop/2.png",
  "/screens/desktop/3.png",
  "/screens/desktop/4.png",
  "/screens/desktop/5.png",
  "/screens/desktop/6.png",
];
const tabletSlides = [
  "/screens/tablet/1.png",
  "/screens/tablet/2.png",
  "/screens/tablet/3.png",
  "/screens/tablet/4.png",
  "/screens/tablet/5.png",
  "/screens/tablet/6.png",
];
const mobileSlides = [
  "/screens/phone/1.png",
  "/screens/phone/2.png",
  "/screens/phone/3.png",
  "/screens/phone/4.png",
  "/screens/phone/5.png",
  "/screens/phone/6.png",
];

const getSlides = (isTablet, isMobile) => {
  if (isMobile) {
    return mobileSlides;
  }
  if (isTablet) {
    return tabletSlides;
  }
  return desktopSlides;
};
const Steps = ({ isAuth, openAuthModal, t }) => {
  const { inView, ref } = useInView({
    triggerOnce: true,
  });
  const [Flickity, setFlickity] = useState(null);
  const isTablet = useMediaQuery({ maxWidth: 991 });
  const isMobile = useMediaQuery({ maxWidth: 570 });
  const slides = getSlides(isTablet, isMobile);
  useEffect(() => {
    import("react-flickity-component").then((module) => setFlickity(module));
  }, []);
  return (
    <S.Wrap ref={ref}>
      <S.Head>
        <h3>{t("titles.5")}</h3>
        <span>{t("subtitles.5")}</span>
      </S.Head>
      <S.InnerWrap>
        <S.ContentWrap>
          <S.SliderAndVideoWrap>
            <S.SliderWrap>
              <S.Slider>
                {Flickity && inView && (
                  <Flickity.default
                    options={sliderConfig}
                    reloadOnUpdate={true}
                    disableImagesLoaded={true}
                  >
                    {slides.map((link) => (
                      <S.Slide src={link} key={link} />
                    ))}
                  </Flickity.default>
                )}
              </S.Slider>
              <S.Mockup />
            </S.SliderWrap>
          </S.SliderAndVideoWrap>
          <S.TextWrap>
            <section>
              <h4>{t("steps_numbers.1")}</h4>
              <p>{t("steps_content.1")}</p>
            </section>
            <section>
              <h4>{t("steps_numbers.2")}</h4>
              <p>{t("steps_content.2")}</p>
            </section>
            <section>
              <h4>{t("steps_numbers.3")}</h4>
              <p>{t("steps_content.3")}</p>
            </section>
            <S.Button
              id="career"
              onClick={openAuthModal}
              disabled={isAuth}
              greenish
              large
            >
              {t("buttons.steps")}
            </S.Button>
          </S.TextWrap>
        </S.ContentWrap>
      </S.InnerWrap>
    </S.Wrap>
  );
};

export default Steps;
